import { gql } from '@apollo/client';

export const DELETE_ADMINISTRATOR = gql`
  mutation DeleteAdministrator($input: DeleteAdministratorInput!) {
    deleteAdministrator(input: $input) {
      administratorId
    }
  }
`;
